export default __webpack_public_path__ + "static/media/us.e834167e.svg";